import { InputLabel, Required } from 'styles/common';
import { MultiSelect, ErrorMessage } from './styles';
import { translate } from 'react-i18next';

export default translate()(({ i18n, input, data, valueField, textField, defaultValue, label, placeholder, isRequired, meta: { touched, error } }) => (
  <div style={{ marginBottom: '20px', textAlign: 'left' }}>
    <InputLabel>
      {label}
      { isRequired && <Required> *</Required> }
    </InputLabel>

    <MultiSelect 
      filter={false}
      data={data}
      defaultValue={defaultValue}
      valueField={valueField}
      textField={textField}
      onChange={input.onChange}
      onSearch={() => {}}
      searchTerm=''
      placeholder={placeholder}
      error={error && touched}/>
    {touched && error && <ErrorMessage>{typeof error === 'string' && i18n.t(error)}</ErrorMessage>}
  </div>
));